import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { I18N_CONFIG } from './config.ts'

import enCommon from './locales/en/common.json'
import itCommon from './locales/it/common.json'

const resources = {
  en: { common: enCommon },
  it: { common: itCommon },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: I18N_CONFIG.defaultLanguage,
    fallbackLng: I18N_CONFIG.fallbackLanguage,
    ns: [...I18N_CONFIG.namespaces],
    defaultNS: I18N_CONFIG.defaultNamespace,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
